var React = require('react');

function Jets (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#2886A2","key":0}),React.createElement("circle",{"stroke":"#FFF","strokeWidth":"2","cx":"16","cy":"16","r":"10","key":1}),React.createElement("path",{"d":"M9 23c4-1 6-4 7-7M25 17c-3-2-6-2-9-1","stroke":"#FFF","strokeLinecap":"round","key":2}),React.createElement("path",{"d":"M14 7c-1 4 0 7 2 9","stroke":"#FFFDFD","strokeLinecap":"round","key":3})]));
}

Jets.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Jets;

Jets.default = Jets;
